import { connect, useDispatch } from "react-redux";
import { getDropdownList } from "../../Shared/dropdownListActions";
import { useEffect, useRef, useState } from "react";
import { VzPageContainer } from "../../../layouts/VzPageContainer";
import { Container, Row, Col, Button, Overlay, Popover } from "react-bootstrap";
import { Formik, Form } from "formik";
import FormikControl from "../../../layouts/Input/FormikControl";
import Moment from "react-moment";
import storage from "../../../apis/Storage";
import { formatDate, renderCell,renderHeader } from "../../../utilities/FUNCTIONS";
import {
  GET_DISTRIBUTOR_DDL,
  GET_ADDJOB_DISTRIBUTIONCENTER_DDL,
  GET_LENDER_DDL,
} from "../../../Types";
import { Link } from "react-router-dom";
import ServerSideDataTable from "../../../layouts/DataTables/ServerSideDataTable/ServerSideDataTable";
import {
  generateCoinListing,
  downloadJob,
  recordCoinRepaymentDetail,
  rejectCoinRepaymentDetail,
} from "./GenerateCoinListingActions";
import { toast } from "react-toastify";

const GenerateCoinListing = (props) => {
  const dispatch = useDispatch();
  const userRights = JSON.parse(storage.get("_userRights"));
  const [target, setTarget] = useState(null);
  const [show, setShow] = useState(false);
  const [readOnly, setReadOnly] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const ref = useRef(null);
  const inputRef = useRef(null);
  // pagination states
  const [currentIndex, setCurrentIndex] = useState();
  const [currentPageNo, setCurrentPageNo] = useState(0);
  const [currentPageSize, setCurrentPageSize] = useState(5);
  const [searchText, setSearchText] = useState("");
  const [totalRecords, setTotalRecords] = useState(0);

  const [distributorList, setDistributorList] = useState([]);
  const [distCenterList, setdistCenterList] = useState([]);
  const [lenderOptions, setLenderOptions] = useState([]);
  const [isApplyFilter, setIsApplyFilter] = useState(false);
  const [isSelectAll, setIsSelectAll] = useState(false);
  const [coinListing, setCoinListing] = useState([]);

  const [filter, setfilter] = useState({
    distId: null,
    distCenterId: null,
    financier: null,
    mfi: null,
    fromDate: new Date(),
    toDate: new Date(),
  });

  const selectAll = () => {
    setIsSelectAll(!isSelectAll);
    let listing = coinListing.map((element) => {
      element.isSelected = !isSelectAll;
      return element;
    });
    setCoinListing(listing);
  };

  const selectRecord = (record) => {
    let listing = [...coinListing];
    let index = listing.findIndex(
      (x) => x.invoiceNumber == record.invoiceNumber
    );
    listing[index].isSelected = !listing[index].isSelected;
    setCoinListing(listing);

    if (
      listing.length == coinListing.filter((x) => x.isSelected == true).length
    ) {
      setIsSelectAll(true);
    } else {
      setIsSelectAll(false);
    }
  };

  const columns = [
    {
      Header: (
        <>
          <div className="ms-2">
            <input
              checked={isSelectAll}
              value={isSelectAll}
              type="checkbox"
              onChange={selectAll}
              style={{ transform: "scale(1.3)" }}
            />
          </div>
        </>
      ),
      accessor: "isSelected",
      Cell: (props) => (
        <>
          <div className="ms-2  ">
            <input
              checked={props.row.original.isSelected}
              value={props.row.original.isSelected}
              type="checkbox"
              onChange={() => selectRecord(props.row.original)}
              style={{ transform: "scale(1.3)" }}
            />
          </div>
        </>
      ),
      isSorted: false,
    },
    {
      Header: "VIZ ID",
      accessor: "vizId",
    },
    {
      Header: "Loan ID",
      accessor: "loanId",
    },
    {
      Header: "Invoice #",
      accessor: "invoiceNumber",
    },
    {
      Header: "Loan Date",
      accessor: "loanDate",
      Cell: (row) => (
        <div style={{ width: "75px" }}>
          {row.value ? <Moment format="DD/MM/YYYY">{row.value}</Moment> : "--"}
        </div>
      ),
    },
     {
      Header: "Paid Date",
      accessor: "paidDate",
      Cell: (row) => (
        <div style={{ width: "75px" }}>
          {row.value ? <Moment format="DD/MM/YYYY">{row.value}</Moment> : "--"}
        </div>
      ),
    },
    {
      Header: renderHeader("Loan Amount"),
      accessor: "loanAmount",
      Cell: ({ value }) => renderCell(value, true),
    },
   
    {
      Header: renderHeader("Paid Amount"),
      accessor: "paidAmount",
      Cell: ({ value }) => renderCell(value, true),
    },
    {
      Header: renderHeader("Profit"),
      accessor: "profit",
      Cell: ({ value }) => renderCell(value, true),
    },
    {
      Header: renderHeader("No Of Days"),
      accessor: "noOfDays",
      Cell: ({ value }) => renderCell(value, true),
    },
    {
      Header: "Coins",
      accessor: "coins",
      Cell: (props) => (
        <>
          <div className="ms-2  ">
            <input
              id={props.row.original.id}
              className="form-control"
              style={{ width: "150px" }}
              value={props.row.original.coins}
              type="text"
              readOnly={true}
              onChange={(e) => {
                setCoins(e.target.value);
                setCoinsById(props.row.original.id, e.target.value);
              }}
            />
          </div>
        </>
      ),
    },
  ];

  const setCoins = (coins) => {
    return coins;
  };

  const setCoinsById = (id, coins) => {
    var list = [...coinListing];
    var index = list.findIndex((x) => x.id == id);
    list[index].coins = coins;
    setCoinListing(list);
  };

  useEffect(() => {
    if (userRights != null && userRights?.userType == "DistributorUser") {
      let distributorList = props.allDistributorList.filter(
        (x) => x.value == userRights?.distId
      );
      if (distributorList?.length > 0) {
        setfilter({
          ...filter,
          distId: {
            label: distributorList[0]?.label,
            value: distributorList[0]?.value,
          },
        });
      }
      setDistributorList(
        distributorList.map(function (item) {
          return {
            value: item.value,
            label: item.label,
          };
        })
      );
    } else if (userRights != null && userRights?.userType == "CoreAppUser") {
      let distributorList = props.allDistributorList.filter((x) =>
        userRights?.distributorId.includes(x.value)
      );
      setDistributorList(
        distributorList.map(function (item) {
          return {
            value: item.value,
            label: item.label,
          };
        })
      );
    } else {
      setDistributorList(
        props.allDistributorList.map(function (item) {
          return {
            value: item.value,
            label: item.label,
          };
        })
      );
    }
  }, [props.allDistributorList]);

  useEffect(() => {
    if (userRights != null && (userRights?.userType == 'DistributorUser' || userRights?.userType == 'CoreAppUser')) {
      let distCenterList = props.selectedAddJobDistCentersList.filter((x) =>
        userRights?.distCenterIds.includes(x.value)
      );
      setdistCenterList(
        distCenterList.map(function (item) {
          return {
            value: item.value,
            label: item.label,
          };
        })
      );
    } else {
      setdistCenterList(
        props.selectedAddJobDistCentersList.map(function (item) {
          return {
            value: item.value,
            label: item.label,
          };
        })
      );
    }
  }, [props.selectedAddJobDistCentersList]);

  useEffect(() => {
    props.getDropdownList(
      `api/Distributor/GetDistributorsDDL`,
      GET_DISTRIBUTOR_DDL
    );
  }, []);

  useEffect(() => {
    if (filter.distId) {
      filter.distCenterId = null;
      props.getDropdownList(
        `api/DistCenter/GetDistCentersDDL/${filter.distId.value}`,
        GET_ADDJOB_DISTRIBUTIONCENTER_DDL
      );
    } else {
      filter.distCenterId = null;
    }
  }, [filter.distId]);

  useEffect(() => {
    props.getDropdownList(`api/Lender/GetLendersDDL`, GET_LENDER_DDL);
  }, []);

  useEffect(() => {
    setLenderOptions(
      props.allLenderList.map(function (item) {
        return {
          value: item.value,
          label: item.label,
        };
      })
    );
  }, [props.allLenderList]);

  function commonReset(reset = true) {
    if (reset) {
      setfilter({
        distId:
          userRights != null && userRights?.userType == "DistributorUser"
            ? filter.distributor
            : null,
        distCenterId: null,
        financier: null,
        mfi: null,
        fromDate: new Date(),
        toDate: new Date(),
        pageNo: 0,
        searchText: null,
      });
    }
  }

  function formRequestObject() {
    let requestData = {
      distId: filter.distId?.value,
      distCenterId: filter.distCenterId?.value,
      financierId: filter.financier?.value,
      mfiId: filter.mfi?.value,
      fromDate: filter.fromDate && formatDate(filter.fromDate),
      toDate: filter.toDate && formatDate(filter.toDate),
      pageSize: currentPageSize,
      pageNo: currentPageNo,
      searchText: searchText,
    };
    if (userRights != null && (userRights?.userType == 'DistributorUser' || userRights?.userType == 'CoreAppUser')) {
      requestData = {
        ...requestData,
        distId: userRights?.distId,
      };
    }
    return requestData;
  }

  function fetchReportData(request) {
    let finalRequest = request == null ? formRequestObject() : request;
    props.generateCoinListing(finalRequest);
  }

  const openFilterModal = (event) => {
    setShow(!show);
    setTarget(event.target);
  };

  const handleResetFilters = (resetForm) => {
    resetForm();
    commonReset();
  };

  const pageSizeChanged = (pageSize) => {
    setCurrentPageNo(0);
    setCurrentPageSize(pageSize);
    var request = { ...formRequestObject(), pageSize: pageSize };
    fetchReportData(request);
  };

  useEffect(() => {
    setCurrentPageNo(0);
    fetchReportData();
  }, []);

  useEffect(() => {
    setCoinListing(props.GenerateCoinListing?.report ?? []);
    setTotalRecords(props.GenerateCoinListing?.totalRecords ?? 0);
  }, [props.GenerateCoinListing]);

  const getData = (page) => {
    setCurrentPageNo(page);
    var request = { ...formRequestObject(), pageNo: page };
    fetchReportData(request);
  };

  const searchChanged = (text) => {
    setSearchText(text);
    ReloadData(text);
  };

  const ReloadData = (text) => {
    setfilter({ ...filter, searchText: text, currentPageNo: 0 });
    var request = {
      ...formRequestObject(),
      searchText: text,
      currentPageNo: 0,
    };
    fetchReportData(request);
  };

  const LoadDataByfilter = (event) => {
    setCurrentPageNo(0);
    var request = { ...formRequestObject(), pageNo: 0 };
    fetchReportData(request);
    setShow(false);
    setIsApplyFilter(true);
  };

  const Download = () => {
    let request = { ...formRequestObject(), isExport: true };
    props.downloadJob(request);
  };

  const RecordCoinRepaymentDetails = async () => {
    var list = [...coinListing].filter((x) => x.isSelected == true);

    if (list.length > 0) {
      await props.recordCoinRepaymentDetail(list);
      await ReloadData("");
    } else {
      toast.info("select atleast one row to save this ledger");
    }
  };

  const RejectCoinRepaymentDetails = async () => {
    var list = [...coinListing].filter((x) => x.isSelected == true);

    if (list.length > 0) {
      await props.rejectCoinRepaymentDetail(list);
      await ReloadData("");
    } else {
      toast.info("select atleast one row to save this ledger");
    }
  };

  return (
    <>
      <VzPageContainer title="VL Loyalty Program > Generate Coin Listing">
        <Row>
          <Col style={{ float: "left" }}>
            <h4>
              <b>Generate Coin Listing</b>
            </h4>
            <br />
          </Col>
        </Row>
        <Row>
          <Col md={8} style={{ float: "right" }}>
            <div ref={ref}>
              <Button
                onClick={openFilterModal}
                className="m-3"
                variant="outline-primary"
              >
                <i className="fa fa-filter"></i>Filters
              </Button>
              <Overlay
                show={show}
                target={target}
                placement="bottom"
                container={ref}
                containerPadding={20}
                width="430px"
                style={{ width: "430px" }}
              >
                <Popover
                  id="popover-contained"
                  style={{ maxWidth: "360px", width: "360px" }}
                >
                  <Popover.Header as="h3">Filters</Popover.Header>
                  <Popover.Body>
                    <Formik
                      enableReinitialize
                      initialValues={filter}
                      validator={() => ({})}
                      onSubmit={LoadDataByfilter}
                    >
                      {(formik) => (
                        <Form autoComplete="off">
                          <Row>
                            {userRights == null && (
                              <Col xs={12} md={12}>
                                <FormikControl
                                  formik={formik}
                                  control="react-select"
                                  label="Distributor"
                                  name="distributor"
                                  options={distributorList}
                                  isClearable={true}
                                  isSearchable={true}
                                  handleOnChange={(e) => {
                                    debugger;
                                    if (!e || !e.value) {
                                      setfilter({
                                        ...filter,
                                        distId: null,
                                      });
                                      return;
                                    }
                                    setfilter({
                                      ...filter,
                                      distId: {
                                        label: e.label,
                                        value: e.value,
                                      },
                                    });
                                  }}
                                  value={filter.distId}
                                />
                              </Col>
                            )}

                            <Col xs={12} md={12}>
                              <FormikControl
                                formik={formik}
                                control="react-select"
                                label="Dist Center"
                                name="distCenter"
                                options={
                                  filter.distId != null ? distCenterList : []
                                }
                                isClearable={true}
                                isSearchable={true}
                                handleOnChange={(e) => {
                                  debugger;
                                  if (!e || !e.value) {
                                    setfilter({
                                      ...filter,
                                      distCenterId: null,
                                    });
                                    return;
                                  }
                                  setfilter({
                                    ...filter,
                                    distCenterId: {
                                      label: e.label,
                                      value: e.value,
                                    },
                                  });
                                }}
                                value={filter.distCenterId}
                              />
                            </Col>
                            <Col xs={12} md={12}>
                              <FormikControl
                                formik={formik}
                                control="react-select"
                                label="Lender"
                                name="financier"
                                options={lenderOptions}
                                isClearable={true}
                                isSearchable={true}
                                handleOnChange={(e) => {
                                  debugger;
                                  if (!e || !e.value) {
                                    setfilter({
                                      ...filter,
                                      financier: null,
                                    });
                                    return;
                                  }
                                  setfilter({
                                    ...filter,
                                    financier: {
                                      label: e.label,
                                      value: e.value,
                                    },
                                  });
                                }}
                                value={filter.financier}
                              />
                            </Col>
                            <Row style={{ paddingRight: 0 }}>
                              <Col xs={12} md={6}>
                                <FormikControl
                                  formik={formik}
                                  type="fromDate"
                                  control="date"
                                  label="From Date"
                                  name="fromDate"
                                  handleOnChange={(value) => {
                                    setfilter({ ...filter, fromDate: value });
                                  }}
                                  value={filter.fromDate}
                                />
                              </Col>
                              <Col xs={12} md={6}>
                                <FormikControl
                                  formik={formik}
                                  control="date"
                                  type="toDate"
                                  label="To Date"
                                  name="toDate"
                                  handleOnChange={(value) => {
                                    setfilter({ ...filter, toDate: value });
                                  }}
                                  value={filter.toDate}
                                />
                              </Col>
                            </Row>
                          </Row>
                          <div className="row" style={{ marginTop: 20 }}>
                            <div className="form-group">
                              <Link
                                onClick={handleResetFilters.bind(
                                  null,
                                  formik.resetForm,
                                  setIsApplyFilter(false)
                                )}
                                to="#"
                                className="active"
                                style={{
                                  padding: "0px",
                                  marginTop: "10px",
                                  float: "left",
                                }}
                              >
                                Reset
                              </Link>
                              <Link
                                onClick={() => {
                                  setShow(false);
                                  setTarget(null);
                                  commonReset(isApplyFilter);
                                }}
                                to="#"
                                className="active"
                                style={{
                                  padding: "0px",
                                  marginTop: "10px",
                                  float: "right",
                                }}
                              >
                                Cancel
                              </Link>
                              <div className="float-right">
                                <Button
                                  type="submit"
                                  className="btn btn-primary"
                                  style={{
                                    marginRight: "10px",
                                    float: "right",
                                  }}
                                >
                                  Apply
                                </Button>
                              </div>
                            </div>
                          </div>
                        </Form>
                      )}
                    </Formik>
                  </Popover.Body>
                </Popover>
              </Overlay>
            </div>
          </Col>
          <Col md={4} style={{ display: "flex", justifyContent: "flex-end" }}>
            <Button
              onClick={RecordCoinRepaymentDetails}
              className="m-3"
              variant="primary"
              style={{ float: "left" }}
            >
              Approve
            </Button>
            <Button
              onClick={RejectCoinRepaymentDetails}
              className="m-3"
              variant="outline-secondary"
              style={{ float: "left" }}
            >
              Reject
            </Button>
            <Button
              onClick={Download}
              className="m-3"
              variant="outline-primary"
            >
              <i className="fa fa-download me-1" />
              Export
            </Button>
          </Col>
        </Row>
        <Row>
          <Col>
            <ServerSideDataTable
              data={props.GenerateCoinListing?.report ?? []}
              columns={columns}
              getTrProps={(event, data) => null}
              goToPreviousPage={(val) => getData(val)}
              goToNextPage={(val) => getData(val)}
              totalRecords={totalRecords}
              pageSizeChange={(size) => pageSizeChanged(size)}
              myPageSize={currentPageSize}
              myIndex={currentIndex}
              pageNo={currentPageNo}
              searchChanged={searchChanged}
            />
          </Col>
        </Row>
      </VzPageContainer>
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    allDistributorList: state.ddlList.allDistributorList
      ? state.ddlList.allDistributorList
      : [],
    selectedAddJobDistCentersList: state.ddlList.selectedAddJobDistCentersList
      ? state.ddlList.selectedAddJobDistCentersList
      : [],
    allLenderList: state.ddlList.lenderList ? state.ddlList.lenderList : [],
    GenerateCoinListing: state.GenerateCoinListing,
  };
};

export default connect(mapStateToProps, {
  getDropdownList,
  generateCoinListing,
  downloadJob,
  recordCoinRepaymentDetail,
  rejectCoinRepaymentDetail,
})(GenerateCoinListing);
